import { isTypeObject as e } from "./helpers/is-type-object.js";
import { getCycleKey as t } from "./helpers/schema-cycle.js";
import { sortPropertyNames as n } from "./helpers/sort-property-names.js";
import r from "./SchemaProperty.vue.js";
import { Fragment as i, computed as a, createBlock as o, createCommentVNode as s, createElementBlock as c, defineComponent as l, openBlock as u, renderList as d, unref as f } from "vue";
import { resolve as p } from "@scalar/workspace-store/resolve";
//#region src/schema/SchemaObjectProperties.vue?vue&type=script&setup=true&lang.ts
var m = /*@__PURE__*/ l({
	__name: "SchemaObjectProperties",
	props: {
		schema: {},
		discriminator: {},
		compact: { type: Boolean },
		hideHeading: { type: Boolean },
		level: {},
		depth: {},
		hideModelNames: { type: Boolean },
		breadcrumb: {},
		eventBus: {},
		options: {},
		schemaContext: {},
		compositionPath: {},
		scrollTargetId: {},
		specificationExtension: {},
		expansion: {}
	},
	setup(l) {
		let m = a(() => n(l.schema, l.discriminator, l.options)), h = (e, t) => {
			let n = typeof e == "boolean" ? e : p.schema(e);
			if (typeof n == "object" && typeof n["x-additionalPropertiesName"] == "string" && n["x-additionalPropertiesName"].trim().length > 0) return `${n["x-additionalPropertiesName"].trim()}`;
			if (t) {
				let e = p.schema(t);
				if (e?.title) return e.title;
			}
			return "propertyName";
		}, g = (e) => {
			if (!e) return;
			let t = p.schema(e);
			if (t && "enum" in t && Array.isArray(t.enum) && t.enum.length > 0) return t.enum;
		}, _ = a(() => {
			if (!(!e(l.schema) || !l.schema.additionalProperties)) return g(l.schema.propertyNames);
		}), v = a(() => {
			if (!(!e(l.schema) || !l.schema.additionalProperties)) return l.schema.propertyNames ? p.schema(l.schema.propertyNames) : void 0;
		}), y = (e) => {
			if (e) return p.schema(e);
		}, b = (e) => {
			if (e) return typeof e.description == "string" ? e.description : void 0;
		}, x = a(() => {
			if (!e(l.schema) || !l.schema.properties) return [];
			let { properties: n } = l.schema, r = new Set(l.schema.required ?? []);
			return m.value.map((e) => {
				let i = n[e];
				return {
					name: e,
					cycleKey: t(i),
					description: b(i),
					required: r.has(e),
					schema: y(i)
				};
			});
		}), S = (e) => {
			let t = typeof e == "boolean" ? e : p.schema(e);
			return t === !0 || typeof t == "object" && Object.keys(t).length === 0 || typeof t != "object" || !("type" in t) ? {
				type: "anything",
				...typeof t == "object" ? t : {}
			} : t;
		};
		return (n, a) => (u(), c(i, null, [
			f(e)(l.schema) && l.schema.properties ? (u(!0), c(i, { key: 0 }, d(x.value, (e) => (u(), o(r, {
				key: e.name,
				breadcrumb: l.breadcrumb,
				compact: l.compact,
				compositionPath: l.compositionPath,
				compositionPathSegment: e.name,
				cycleKey: e.cycleKey,
				depth: l.depth,
				description: e.description,
				discriminator: l.discriminator,
				eventBus: l.eventBus,
				expansion: l.expansion,
				hideHeading: l.hideHeading,
				hideModelNames: l.hideModelNames,
				level: l.level,
				name: e.name,
				options: l.options,
				required: e.required,
				schema: e.schema,
				schemaContext: l.schemaContext,
				scrollTargetId: l.scrollTargetId,
				specificationExtension: l.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"compositionPathSegment",
				"cycleKey",
				"depth",
				"description",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"name",
				"options",
				"required",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			]))), 128)) : s("", !0),
			f(e)(l.schema) && l.schema.patternProperties ? (u(!0), c(i, { key: 1 }, d(Object.entries(l.schema.patternProperties), ([e, n]) => (u(), o(r, {
				key: e,
				breadcrumb: l.breadcrumb,
				compact: l.compact,
				compositionPath: l.compositionPath,
				compositionPathSegment: e,
				cycleKey: f(t)(n),
				depth: l.depth,
				description: b(n),
				discriminator: l.discriminator,
				eventBus: l.eventBus,
				expansion: l.expansion,
				hideHeading: l.hideHeading,
				hideModelNames: l.hideModelNames,
				level: l.level,
				name: e,
				options: l.options,
				schema: y(n),
				schemaContext: l.schemaContext,
				scrollTargetId: l.scrollTargetId,
				specificationExtension: l.specificationExtension
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"compositionPathSegment",
				"cycleKey",
				"depth",
				"description",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"name",
				"options",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			]))), 128)) : s("", !0),
			f(e)(l.schema) && l.schema.additionalProperties ? (u(), o(r, {
				key: 2,
				breadcrumb: l.breadcrumb,
				compact: l.compact,
				compositionPath: l.compositionPath,
				compositionPathSegment: h(l.schema.additionalProperties, l.schema.propertyNames),
				cycleKey: f(t)(l.schema.additionalProperties),
				depth: l.depth,
				discriminator: l.discriminator,
				eventBus: l.eventBus,
				expansion: l.expansion,
				hideHeading: l.hideHeading,
				hideModelNames: l.hideModelNames,
				level: l.level,
				name: h(l.schema.additionalProperties, l.schema.propertyNames),
				noncollapsible: "",
				options: l.options,
				propertyNamesEnum: _.value,
				propertyNamesSchema: v.value,
				schema: S(l.schema.additionalProperties),
				schemaContext: l.schemaContext,
				scrollTargetId: l.scrollTargetId,
				specificationExtension: l.specificationExtension,
				variant: "additionalProperties"
			}, null, 8, [
				"breadcrumb",
				"compact",
				"compositionPath",
				"compositionPathSegment",
				"cycleKey",
				"depth",
				"discriminator",
				"eventBus",
				"expansion",
				"hideHeading",
				"hideModelNames",
				"level",
				"name",
				"options",
				"propertyNamesEnum",
				"propertyNamesSchema",
				"schema",
				"schemaContext",
				"scrollTargetId",
				"specificationExtension"
			])) : s("", !0)
		], 64));
	}
});
//#endregion
export { m as default };

//# sourceMappingURL=SchemaObjectProperties.vue.script.js.map